import Link from 'next/link';
import Layout from '@/components/layout';
import HowItWorksCard from '@/components/pages/membership/HowItWorksCard';
import { Pages } from '@/lib/seoData';
import { NextSSRPage, withServerSideProps } from 'hoc/withServerSideProps';

const aboutCards = [
  {
    headline: "Discovery",
    description: "Members get exclusive access to Daily Polished approved and tested selection of emerging beauty and lifestyle brands at up to 60% off retail."
  },
  {
    headline: "Full size experience",
    description: "No sample size products, close-outs or unwanted products. Buy only what you want at up to 60% off retail. Choose your favorites instead of taking the risk of a beauty box subscription."
  },
  {
    headline: "Reduce waste",
    description: "Size matters and our mission is to eliminate sample size products that are wasteful, bad for the environment and skimp on the full brand experience."
  }
]

const About: NextSSRPage = (props) => (
  <Layout {...props}>
    <div className="bg-cloud flex flex-col justify-center items-center py-20 px-4 lg:px-16">
      <div className='text-center max-w-5xl'>
        <h1 className="sr-only">About Daily Polished</h1>
        <h2 className="text-center leading-8 text-3xl lg:text-4xl mb-10">
          Daily Polished is the essential destination to discover{' '}
          <br className="hidden lg:block" />
          beauty and lifestyle brands at up to 60% off.
        </h2>
        <div className="leading-6 space-y-5 md:px-10">
          <p>
            Our brand drops can be accessed without membership privileges and non-members can enjoy the element of surprise and beauty discovery at 50% off retail for a limited time.
          </p>
          <p>
            Our members enjoy a curated discovery experience of hand-selected beauty and lifestyle brands that are unique, innovative and highly effective.
          </p>
          <p>
            With exclusive access to our <strong>member store</strong>, our members can find new and exciting products that are Daily Polished tested and approved, and available to try at up to 60% off retail all year round.
          </p>
          <p>
            We offer two membership levels to fit your lifestyle. The <strong>Enthusiast</strong> is a monthly membership with zero commitment. The <strong>Loyalist</strong> is an annual membership created for those who understand the value and want to discover full size products at sample size prices.
          </p>
          <p>
            We are not subscription beauty box filled with junk and sample size products. We give our members full control over what beauty and lifestyle products they need or want to try.
          </p>
        </div>
      </div>
    </div>
    <div className="py-10 px-6 lg:pt-14 lg:pb-20">
      <div className="container flex flex-col mx-auto justify-center p-4 lg:py-14">
        <div className="flex flex-col gap-8 lg:flex-row justify-center">
          {aboutCards.map((card) => <HowItWorksCard
            key={card.headline}
            headline={card.headline}
            description={card.description}
            hasBgc
          />)}
        </div>
        <div className="text-center mt-10 lg:mt-20">
          <Link href="/">
            <button className="bg-onyx border py-4 px-4 text-white uppercase md:w-1/4">
              Become a member
            </button>
          </Link>
        </div>
      </div>
    </div>
  </Layout>
);

export const getServerSideProps = withServerSideProps(async function () {
  return { props: {} }
}, Pages.ABOUT)

export default About;
